<div class="user-list page">
  <app-breadcrumbs [breadcrumbs]="breadcrumbs" />
  <div class="heading-wrapper">
    <h4>{{ 'pages.user.title' | translate }}</h4>
    <div class="actions">
      <button
        class="secondary download-excel"
        [disabled]="isExcelDownloading"
        [ngClass]="{ downloading: isExcelDownloading }"
        (click)="getExcelFile()">
        @if (!isExcelDownloading) {
          <img src="assets/images/download-excel.svg" alt="download-excel.svg" />
          {{ 'pages.user.saveExcel' | translate }}
        } @else {
          <div class="spinner-wrapper">
            <div class="spinner"></div>
          </div>
        }
      </button>
    </div>
  </div>
  <app-table
    [columns]="tableColumns"
    [endpoint]="apiPath"
    [flatTopBorder]="true"
    sortBy="fullName"
    viewEntryPath="/lietotajs/{id}/rediget" />
</div>
